import axios from 'axios'

const { REACT_APP_BUCKET } = process.env

const ImageUploadToS3 = async (image, path = 'images/parceiros/', fileName = null) => {
  try {
    const url = `${process.env.REACT_APP_API_UPLOAD_URL}fileupload`

    const config = {
      headers: { ContentType: 'multipart/form-data' }
    }

    const bodyFormData = new FormData()

    bodyFormData.set('type', 'file')
    bodyFormData.set('bucket', REACT_APP_BUCKET)
    bodyFormData.set('path', path)

    fileName && bodyFormData.set('fileName', fileName)

    bodyFormData.append('file', image)

    const res = await axios.post(url, bodyFormData, config)
    return res.data.path
  } catch (e) {
    console.log({ error: e })
    return false
  }
}

export default ImageUploadToS3
